<template>
  <section class="video-controls btn-group btn-group-sm">
    <!-- <button -->
    <!--   class="btn btn-secondary" -->
    <!--   @click.stop.prevent="$emit('videoStyleChange', 'reset')"> -->
    <!--     reset -->
    <!-- </button> -->
    <!-- <button -->
    <!--   class="btn btn-secondary" -->
    <!--   @click.stop.prevent="$emit('videoStyleChange', 'flipHorizontal')"> -->
    <!--     flip horizontally -->
    <!-- </button> -->
    <!-- <button -->
    <!--   class="btn btn-secondary" -->
    <!--   @click.stop.prevent="$emit('videoStyleChange', 'flipVertical')"> -->
    <!--     flip vertically -->
    <!-- </button> -->
    <!-- <button -->
    <!--   class="btn btn-secondary" -->
    <!--   @click.stop.prevent="$emit('videoStyleChange', 'rLeft')"> -->
    <!--     rotate left -->
    <!-- </button> -->
    <!-- <button -->
    <!--   class="btn btn-secondary" -->
    <!--   @click.stop.prevent="$emit('videoStyleChange', 'rRight')"> -->
    <!--     rotate right -->
    <!-- </button> -->
    <button
      class="btn btn-secondary"
      @click.stop.prevent="$emit('setVideoQulity', 'LOW')">
        LOW
    </button>
    <button
      class="btn btn-secondary"
      @click.stop.prevent="$emit('setVideoQulity', 'MEDIUM')">
        MIDIUM
    </button>
    <button
      class="btn btn-secondary"
      @click.stop.prevent="$emit('setVideoQulity', 'HIGH')">
        HIGH
    </button>
  </section>
</template>

<script>
// import { mapGetters, mapState } from 'vuex'

export default {
  name: 'VideoControls',

  date () {
    return {}
  },

  computed: {
  },

  methods: {
    // setVideoQulity (qulity) {
    //
    // }
  }
}
</script>

<style scoped>
</style>
